import type { CustomIconProps } from '../types';

const MagnifyingGlassZoomOut = ({ width, height, color }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.93714 8.91429C7.13366 8.91429 8.91429 7.13366 8.91429 4.93714C8.91429 2.74063 7.13366 0.96 4.93714 0.96C2.74063 0.96 0.96 2.74063 0.96 4.93714C0.96 7.13366 2.74063 8.91429 4.93714 8.91429ZM4.93714 9.87429C6.12764 9.87429 7.21972 9.45292 8.07238 8.7512L11.1806 11.8594C11.368 12.0468 11.6719 12.0468 11.8594 11.8594C12.0468 11.6719 12.0468 11.368 11.8594 11.1806L8.7512 8.07238C9.45292 7.21972 9.87429 6.12764 9.87429 4.93714C9.87429 2.21043 7.66385 0 4.93714 0C2.21043 0 0 2.21043 0 4.93714C0 7.66385 2.21043 9.87429 4.93714 9.87429ZM2.88 4.32C2.6149 4.32 2.4 4.5349 2.4 4.8C2.4 5.0651 2.6149 5.28 2.88 5.28H6.72C6.9851 5.28 7.2 5.0651 7.2 4.8C7.2 4.5349 6.9851 4.32 6.72 4.32H2.88Z"
            fill={color || '#414042'}
        />
    </svg>
);

export default MagnifyingGlassZoomOut;
